import script from "./myfooter.vue?vue&type=script&setup=true&lang=js"
export * from "./myfooter.vue?vue&type=script&setup=true&lang=js"

import "./myfooter.vue?vue&type=style&index=0&id=aeba6ba0&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeba6ba0"]])

export default __exports__